import React, { useState } from "react";
import { Container, Row, Col } from "bootstrap-4-react";
import ReactImageVideoLightbox from "react-image-video-lightbox";
import * as apiUrl from "../../apiUrl";

export default function EventsGallery({ imageGallery = "[]", videoGallery = "[]" }) {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Parse JSON strings
  const parsedImageGallery = JSON.parse(imageGallery);
  const parsedVideoGallery = JSON.parse(videoGallery);

  // Helper to extract YouTube ID
  const extractYouTubeId = (url) => {
    const regExp = /^.*(?:youtu.be\/|v\/|embed\/|watch\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[1] ? match[1] : null;
  };

  // Combine image and video data
  const data = [
    ...parsedImageGallery.map((image, index) => ({
      url: `${apiUrl.apiUrl}/${image}`,
      thumbnail: `${apiUrl.apiUrl}/${image}`,
      type: "photo",
    })),
    ...parsedVideoGallery.map((video, index) => ({
      url: video,
      thumbnail: `https://img.youtube.com/vi/${extractYouTubeId(video)}/0.jpg`,
      type: "video",
    })),
  ];



  const openLightbox = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  // Render rows with flexible layout
  const renderRow = (items, layoutType) => {
    switch (layoutType) {
      case "8-4":
        return (
          <Row key={items[0]?.url}>
            <Col md={8}>
              {items[0] && renderItem(items[0])}
            </Col>
            <Col md={4}>{items[1] && renderItem(items[1])}</Col>
          </Row>
        );
      case "12":
        return (
          <Row key={items[0]?.url}>
            <Col md={12}>{items[0] && renderItem(items[0])}</Col>
          </Row>
        );
      case "7-5":
        return (
          <Row key={items[0]?.url}>
            <Col md={7}>{items[0] && renderItem(items[0])}</Col>
            <Col md={5}>{items[1] && renderItem(items[1])}</Col>
          </Row>
        );
      default:
        return null;
    }
  };

  const renderItem = (item) => (
    <div className="zoomImageDiv paddingRightDiv">
      <div className="zoomImage">
        <img
          src={item.thumbnail}
          onClick={() => openLightbox(data.indexOf(item))}
          className="img-fluid"
          alt="Luxury real estate Developer Dubai"
        />
      </div>
    </div>
  );

  // Dynamically generate rows
  const rows = [];
  for (let i = 0; i < data.length;) {
    if (i + 2 <= data.length) {
      rows.push(renderRow(data.slice(i, i + 2), "8-4"));
      i += 2;
    }
    if (i + 1 <= data.length) {
      rows.push(renderRow(data.slice(i, i + 1), "12"));
      i += 1;
    }
    if (i + 2 <= data.length) {
      rows.push(renderRow(data.slice(i, i + 2), "7-5"));
      i += 2;
    }
    if (i + 1 <= data.length) {
      rows.push(renderRow(data.slice(i, i + 1), "12"));
      i += 1;
    }
  }

  return (
    <section className="events-gallery-sec events-list-sec">
      <Container fluid>
        {rows}

        {open && (
          <div className="lightBox">
            <ReactImageVideoLightbox
              data={data}
              startIndex={currentIndex}
              showResourceCount={true}
              onCloseCallback={() => setOpen(false)}
              onNavigationCallback={(currentIndex) =>
                console.log(`Current index: ${currentIndex}`)
              }
            />
          </div>
        )}
      </Container>
    </section>
  );
}
